/**
 * Derives product availability flags from context data
 * Eliminates duplicated stock/availability logic across AddToCartSection, StockStatus, etc.
 */
import { findCustomAttributeValue, DISCONTINUED_CATEGORY_ID } from '../../lib'
import { useProductAttributes } from '../../state'

export interface ProductAvailability {
  isInStock: boolean
  showAddToCart: boolean
  isDiscontinued: boolean
  isBundle: boolean
  productTypeId: string | undefined
}

export function useProductAvailability(): ProductAvailability {
  const { productAttributes, customAttributes, categories } = useProductAttributes()

  const productTypeId = productAttributes?.type_id
  const isInStock = findCustomAttributeValue(customAttributes, 'is_in_stock') === 'In Stock'
  const showAddToCart = findCustomAttributeValue(customAttributes, 'cu_fara_pret') === 'Da'
  const isDiscontinued = categories?.some((category) => category.id === DISCONTINUED_CATEGORY_ID) ?? false
  const isBundle = productTypeId === 'bundle'

  return {
    isInStock,
    showAddToCart,
    isDiscontinued,
    isBundle,
    productTypeId,
  }
}
